import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { motion } from 'framer-motion';
import { useRef, useMemo, cloneElement } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { useResizeObserver } from '../../hooks/useResizeObserver.js';
import { B as Box } from '../Box/Box.js';
import { useTheme } from '../../hooks/useTheme.js';

var _excluded = ["motionProfile", "testId", "sx", "innerContainerSx", "children", "rc", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AnimateHeightBox(_ref) {
  var _ref2;
  var motionProfile = _ref.motionProfile,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "AnimateHeightBox" : _ref$testId,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$innerContainerSx = _ref.innerContainerSx,
    innerContainerSx = _ref$innerContainerSx === void 0 ? {} : _ref$innerContainerSx,
    children = _ref.children,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx(motion.div, {}) : _ref$rc,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var innerContainerRef = useRef(null);
  var _useResizeObserver = useResizeObserver(innerContainerRef),
    height = _useResizeObserver.height;
  var _useTheme = useTheme(),
    base = _useTheme.base,
    globalConfig = _useTheme.globalConfig;
  var motionProfileToUse = (_ref2 = motionProfile !== null && motionProfile !== void 0 ? motionProfile : globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.motionProfile) !== null && _ref2 !== void 0 ? _ref2 : "gentle";
  var mergedSx = useMemo(function () {
    return merge({
      pos: "relative",
      w: "100%",
      h: "auto"
    }, sx);
  }, [sx]);
  return jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " AnimateHeightBox"),
    sx: mergedSx,
    rc: /*#__PURE__*/cloneElement(rc, _objectSpread({}, motionProfileToUse !== "none" ? {
      animate: {
        height: height || "auto"
      },
      transition: {
        duration: base.motion.normal[motionProfileToUse].jsDuration,
        ease: base.motion.normal[motionProfileToUse].jsEase
      }
    } : {})),
    children: jsx(Box, {
      domRef: innerContainerRef,
      testId: "".concat(testId, "__innerContainer"),
      className: "innerContainer",
      sx: innerContainerSx,
      children: children
    })
  }));
}
AnimateHeightBox.displayName = "AnimateHeightBox";

export { AnimateHeightBox as A };
//# sourceMappingURL=AnimateHeightBox.js.map
